import { __awaiter, __generator } from "tslib";
export var waitForSuccessfulResponse = function (url, getHttpClientPromise, timeout) {
    if (timeout === void 0) { timeout = 45000; }
    return __awaiter(void 0, void 0, void 0, function () {
        var timeoutTimestamp, withRetry, httpClient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timeoutTimestamp = Date.now() + timeout;
                    withRetry = function (invoke, resolve, reject) {
                        invoke()
                            .then(resolve)
                            .catch(function () {
                            setTimeout(function () {
                                if (Date.now() < timeoutTimestamp) {
                                    withRetry(invoke, resolve, reject);
                                }
                                else {
                                    reject();
                                }
                            }, 1000);
                        });
                    };
                    return [4 /*yield*/, (getHttpClientPromise === null || getHttpClientPromise === void 0 ? void 0 : getHttpClientPromise())];
                case 1:
                    httpClient = _a.sent();
                    return [2 /*return*/, Promise.race([
                            new Promise(function (res, rej) {
                                return withRetry(function () { return httpClient === null || httpClient === void 0 ? void 0 : httpClient.get(url).then(function (r) { return (r.status < 400 ? r : Promise.reject(r)); }); }, res, rej);
                            }),
                            new Promise(function (res) { return setTimeout(res, timeout); }),
                        ])];
            }
        });
    });
};
//# sourceMappingURL=waitForSuccessfulResponse.js.map